import { ToggleContainer, DialogButton } from './Toggle.styles';

interface IToggle {
  selected: boolean;
  toggleSelected: () => void;
}

const Toggle = ({ selected, toggleSelected }: IToggle) => {
  return (
    <ToggleContainer active={selected} onClick={toggleSelected}>
      <DialogButton active={selected} />
    </ToggleContainer>
  );
};

export { Toggle };
